// =====================================================================
// BadgeTest.jsx — Commandes prêtes v2 (16-10-2026) — badge « TEST »
// =====================================================================
// Signal de sécurité : une commande de test (mail seulement à l'adresse de test,
// rien vers EffiTrace, invisible pour le client) se reconnaît partout pareil —
// liste, écran PDA, chargement. Un seul style, ici.
// =====================================================================

const STYLE = {
  display: 'inline-block', background: '#7c2d12', color: '#fff', borderRadius: 6, padding: '0 6px',
  fontSize: '0.72rem', fontWeight: 800, letterSpacing: '.04em', lineHeight: 1.6, verticalAlign: 'middle',
};

export default function BadgeTest({ style }) {
  return (
    <span style={style ? { ...STYLE, ...style } : STYLE} title="Commande de test : mail seulement à l'adresse de test, rien vers EffiTrace">
      TEST
    </span>
  );
}
